// extracted by mini-css-extract-plugin
module.exports = {"header":"ManageBusiness_header__YAXqC"};